<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10PWf4j/tc-custom/9781429933223.jpg?1746161701847" alt="This image is the cover for the book 03"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">03
      </h1>
      <p class="bookDescription body article font2">
        <p>"From the bus stop across the street, it was hard to tell, but suddenly I understood, seeing the passengers in the van that picked her up every morning, that she was slightly retarded."<br/><br/>A precocious teenager in a French suburb finds himself powerfully, troublingly drawn to the girl he sees every day on the way to school. As he watches and thinks about her, his daydreams—full of lyrics from Joy Division and the Smiths, fairy tales, <i>Flowers</i><i>for Algernon</i>, sexual desire and fear, loneliness, rage for escape, impatience to grow up—reveal an entire adolescence. And this fleeting erotic obsession, remembered years later, blossoms into a meditation on what it means to be a smart kid, what it means to be dumb, and what it means to be in love with another person. <br/><br/><i>03 </i>is a book about young love like none you have ever read. It marks the English-language debut of a unique French writer—one of the great stylists of his generation.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jean-Christophe Valtat
      </h2>
      
      <p class="authorDescription body article"><P><B>Jean-Christophe Valtat </B>teaches comparative literature at Clermont-Ferrand University. He is the author of two novels and a story collection. <br><br><B>Mitzi Angel </B>is the publisher of Faber and Faber, Inc.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f69f870e